import {Pause, Play, PlayFill, StopFill} from "react-bootstrap-icons";
import React from "react";

export function NavigationSkills({navigationSkill}) {
    return (
        <>
            {/*<div>{JSON.stringify(navigationSkills)}</div>*/}
            {<div className={"text-nowrap"}><i>{navigationSkill.identifier?.replaceAll("_", " ") ?? ""}</i></div>}
            {navigationSkill.hasError ? <div className={"text-truncate"}><strong>error</strong></div> : null}
            {navigationSkill.isReady ? <div className={"text-truncate"}><Play/> <strong>ready</strong></div> : null}
            {navigationSkill.isPlayback ? <div className={"text-truncate"}><strong>playback</strong></div> : null}
            {navigationSkill.isManual ? <div className={"text-truncate"}><Pause/><strong>manual</strong></div> : null}
            {navigationSkill.isDependency ? <div className={"text-truncate"}><Pause/> <strong>dependency</strong></div> : null}
            {navigationSkill.isOperatorRequired ? <div className={"text-truncate"}><Pause/> <strong>operator required</strong></div> : null}
            {navigationSkill.isMachineActive ? <div className={"text-truncate"}><PlayFill/> <strong> active ({navigationSkill.progress ?? 0}%)</strong></div> : null}
            {navigationSkill.isFinished ? <div className={"text-truncate"}><StopFill/> <strong>finished</strong></div> : null}
        </>
    );
}